export interface MfaMethodFlags {
    readonly totp_enabled: boolean;
    readonly mfa_email_allowed?: boolean;
    readonly mfa_sms_allowed?: boolean;
}

export function hasConfiguredMfaMethod(user: MfaMethodFlags): boolean {
    return (
        user.totp_enabled === true ||
        user.mfa_email_allowed === true ||
        user.mfa_sms_allowed === true
    );
}
